import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  welcomePageMissing: {
    id: 'eventTile.welcomePageMissing',
    defaultMessage: 'Welcome page missing',
  },
  closingPageMissing: {
    id: 'eventTile.closingPageMissing',
    defaultMessage: 'Closing page missing',
  },
})
